import type { CommerceCart, CommerceEnrollmentSession } from "@teqtank/commerce-contracts";
import { resolveCommerceCart } from "../cart/cart-response-resolver.js";

export function resolveCommerceEnrollment(
    value: CommerceEnrollmentSession,
): CommerceEnrollmentSession;
export function resolveCommerceEnrollment(
    value: CommerceEnrollmentSession | null,
): CommerceEnrollmentSession | null;
export function resolveCommerceEnrollment(
    value: CommerceEnrollmentSession | null,
): CommerceEnrollmentSession | null {
    if (value === null) return null;

    const cart = resolveCommerceCart({
        id: value.cart.id,
        version: value.cart.version,
        currencyCode: value.cart.currencyCode,
        lines: value.cart.lines.map((entry) => entry.line),
        coupons: [],
        totals: value.cart.totals,
        updatedAt: value.updatedAt,
    } satisfies CommerceCart);

    return Object.freeze({
        ...value,
        eligibility: Object.freeze({ ...value.eligibility }),
        currentStage: freezeStage(value.currentStage),
        stages: Object.freeze(value.stages.map(freezeStage)),
        categories: Object.freeze(
            value.categories.map((category) => Object.freeze({ ...category })),
        ),
        kits: Object.freeze(
            value.kits.map((kit) =>
                Object.freeze({
                    ...kit,
                    product: Object.freeze({ ...kit.product }),
                    highlights: Object.freeze([...kit.highlights]),
                }),
            ),
        ),
        cart: Object.freeze({
            id: cart.id,
            version: cart.version,
            currencyCode: cart.currencyCode,
            lines: Object.freeze(
                value.cart.lines.map((entry, index) =>
                    Object.freeze({
                        ...entry,
                        line: cart.lines[index]!,
                    }),
                ),
            ),
            totals: cart.totals,
        }),
        createdAt: resolveDate(value.createdAt),
        updatedAt: resolveDate(value.updatedAt),
    });
}

function freezeStage(stage: CommerceEnrollmentSession["currentStage"]) {
    return Object.freeze({
        ...stage,
        presentation: Object.freeze({ ...stage.presentation }),
        progress: Object.freeze({ ...stage.progress }),
        allowedOutcomes: Object.freeze([...stage.allowedOutcomes]),
    });
}

function resolveDate(value: Date): Date {
    const date =
        value instanceof Date ? new Date(value.getTime()) : new Date(value as unknown as string);
    return Object.freeze(date);
}
